import React, { CSSProperties, useEffect, useState } from 'react';
import * as componentStyle from './blogFaq.module.scss';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';



interface Faq {
  question: string | null;
  answer: string | null;
}
interface BlogFaqDataInterface {
  heading: string | null;
  faq: Faq[] | null;
}
interface BlogFaqInterface {
  blogFaqData: BlogFaqDataInterface | null;
}
export default function BlogFaq({ data, className }: { data?: BlogFaqInterface | null, className?: string }) {

  const modifiedData = data?.blogFaqData?.faq?.map((el, index) => ({...el, id: `ans${index + 1}`}));
    
    
    const [activeItemHeight, setActiveItemHeight] = useState(0);
  
    const handleAccordionChange = (currentFaqId) => {
      const activeFaqItem = modifiedData?.find((faq) => faq.id === currentFaqId[0]);
      if (activeFaqItem) {
        const getElementHeight = document.querySelectorAll(`#accordion__panel-${activeFaqItem.id} .itemPanel`);
        setActiveItemHeight(getElementHeight[0]?.scrollHeight + 1);
      }
    };
  
    useEffect(() => {
      const getLoadElementHeight = document.querySelectorAll(`#accordion__panel-ans1 .itemPanel`);
      if (getLoadElementHeight.length > 0) {
        window.addEventListener("scroll", () => {
          setActiveItemHeight(getLoadElementHeight[0]?.scrollHeight + 1);
        }, { once: true });
      }
    }, []);

  return (
    <section className={`${componentStyle.blogFaq} ${className && className}`}>
      <div>
        {!!data && (
          <>
            <div className={componentStyle.blogFaq__headingArea}>
              {data.blogFaqData?.heading && (<div className={componentStyle.blogFaq__heading} dangerouslySetInnerHTML={{ __html: data.blogFaqData?.heading }}></div>)}
            </div>

            <div className={componentStyle.blogFaq__contextArea}>
              <Accordion
                onChange={handleAccordionChange}
                preExpanded={modifiedData && [modifiedData[0].id]}
                className={componentStyle.blogFaq__accordion}
              >
                {modifiedData?.map((context) => (
                  <AccordionItem uuid={context?.id} key={context?.id} className={componentStyle.blogFaq__accordionItem}>
                    <AccordionItemHeading>
                      <AccordionItemButton className={componentStyle.blogFaq__accordionButton}>
                        {context?.question && (<h3 className={componentStyle.blogFaq__accordionHeading}>{context?.question}</h3>)}
                        <div className={componentStyle.blogFaq__arrowBox}>
                          <img src='../../../images/services/right-arrow.svg' alt='Right Arrow' />
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    
                    <AccordionItemPanel className={componentStyle.blogFaq__accordionItemPanel} style={{ "--height": `${activeItemHeight}px` } as CSSProperties}>
                      <div className={`${componentStyle.blogFaq__accordionPanel} itemPanel`}>
                        {context?.answer && (<div className={componentStyle.blogFaq__accordionParagraph} dangerouslySetInnerHTML={{ __html: context?.answer }}></div>)}
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
